// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.opt-form {
  margin-top: var(--space-lg);
}
.opt-form flw-input {
  --width: 100%;
}
.opt-form .otp-input-row {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  width: 100%;
}
.opt-form .otp-input-row .otp-input {
  flex: 1;
  min-width: 0;
}
.opt-form .otp-input-row flw-button flw-icon {
  --cursor: pointer;
}
.opt-form .otp-input-row flw-button::part(native) {
  height: 48px;
}
.opt-form .otp-error {
  display: block;
  margin-top: 8px;
  color: var(--ion-color-danger);
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/otp-form/otp-form.component.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;AACJ;AACI;EACI,aAAA;AACR;AAEI;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,WAAA;AAAR;AAEQ;EACI,OAAA;EACA,YAAA;AAAZ;AAGQ;EACI,iBAAA;AADZ;AAIQ;EACI,YAAA;AAFZ;AAMI;EACI,cAAA;EACA,eAAA;EACA,8BAAA;EACA,eAAA;AAJR","sourcesContent":[".opt-form {\r\n    margin-top: var(--space-lg);\r\n\r\n    flw-input {\r\n        --width: 100%;\r\n    }\r\n\r\n    .otp-input-row {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: var(--space-sm);\r\n        width: 100%;\r\n\r\n        .otp-input {\r\n            flex: 1;\r\n            min-width: 0;\r\n        }\r\n\r\n        flw-button flw-icon {\r\n            --cursor: pointer;\r\n        }\r\n\r\n        flw-button::part(native) {\r\n            height: 48px;\r\n        }\r\n    }\r\n\r\n    .otp-error {\r\n        display: block;\r\n        margin-top: 8px;\r\n        color: var(--ion-color-danger);\r\n        font-size: 13px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
